import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cr2000',
    ecrans: ['00-2'],
    params: ['refcleint']
});
